import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'm-layout-content',
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true,
  exportAs: 'mLayoutContent',
  host: {
    class: 'm-layout-content'
  }
})
export class MLayoutContentComponent {}
